import React, { useEffect } from 'react';
import parse from 'html-react-parser';
import template from './slider-3.twig';
import legacyJs from './slider-3.legacy';
import { jsx as _jsx } from "react/jsx-runtime";

var Slider3 = function Slider3(props) {
  useEffect(function () {
    legacyJs.init();
  }, [props]);
  return /*#__PURE__*/_jsx(React.Fragment, {
    children: parse(template(props))
  }, JSON.stringify(props));
};

export default Slider3;